module.exports = __webpack_public_path__ + "img/MapThumb_ShelteredPass.4f9ddaba.webp";